document.addEventListener("DOMContentLoaded", () => {

    const MAX_PRODUCTS = 7;

    let selected = [];

    const buttons = document.querySelectorAll(".buy7-btn");

    const progress = document.getElementById("buy7-progress-bar");

    const counter = document.getElementById("buy7-count");

    const footerCounter = document.getElementById("buy7-footer-count");

    const cartBtn = document.getElementById("buy7-cart");

    // ===========================
    // UPDATE UI
    // ===========================

    function updateUI() {

        const total = selected.length;

        // Counter

        if (counter) {
            counter.textContent = total;
        }

        if (footerCounter) {
            footerCounter.textContent = total;
        }

        // Progress Bar

        if (progress) {
            progress.style.width = ((total / MAX_PRODUCTS) * 100) + "%";
        }

        // Enable Button only when exactly 7 selected

        if (cartBtn) {
            cartBtn.disabled = total !== MAX_PRODUCTS;
        }

        // Disable remaining buttons after 7 selected

        buttons.forEach(btn => {

            const card = btn.closest(".buy7-card");

            if (!card.classList.contains("buy7-selected") && total >= MAX_PRODUCTS) {

                btn.disabled = true;
                btn.textContent = "Bundle Full";

            } else if (!card.classList.contains("buy7-selected")) {

                btn.disabled = false;
                btn.textContent = "+ Add To Bundle";

            }

        });

    }

    // ===========================
    // SELECT / REMOVE PRODUCTS
    // ===========================

    buttons.forEach(button => {

        button.addEventListener("click", function () {

            const card = this.closest(".buy7-card");

            const variant = card.dataset.variantId;

            const index = selected.indexOf(variant);

            // REMOVE PRODUCT

            if (index > -1) {

                selected.splice(index, 1);

                this.classList.remove("selected");

                this.innerHTML = "+ Add To Bundle";

                this.disabled = false;

                card.classList.remove("buy7-selected");

                updateUI();

                return;

            }

            // MAX LIMIT

            if (selected.length >= MAX_PRODUCTS) {

                alert("You can select only 7 products in this bundle.");

                return;

            }

            // ADD PRODUCT

            selected.push(variant);

            this.classList.add("selected");

            this.innerHTML = "✓ Added";

            card.classList.add("buy7-selected");

            updateUI();

        });

    });

    // ===========================
    // ADD TO CART
    // ===========================

    if (cartBtn) {

        cartBtn.addEventListener("click", async () => {

            // EXACTLY 7 PRODUCTS

            if (selected.length !== MAX_PRODUCTS) {

                alert("Please select exactly 7 products.");

                return;

            }

            cartBtn.disabled = true;

            cartBtn.innerHTML = "Adding Bundle...";

            // Create unique bundle id

            const bundleId = "BUNDLE-" + Date.now();

            const items = [];

            selected.forEach(id => {

                items.push({

                    id: Number(id),

                    quantity: 1,

                    properties: {

                        "Bundle": "Buy Any 7 @ ₹599",

                        "Bundle ID": bundleId

                    }

                });

            });

            try {

                await fetch("/cart/add.js", {

                    method: "POST",

                    headers: {

                        "Content-Type": "application/json"

                    },

                    body: JSON.stringify({

                        items: items

                    })

                });

                // Reset UI

                selected = [];

                buttons.forEach(btn => {

                    btn.classList.remove("selected");

                    btn.disabled = false;

                    btn.innerHTML = "+ Add To Bundle";

                    btn.closest(".buy7-card").classList.remove("buy7-selected");

                });

                updateUI();

                // Redirect to cart

                window.location.href = "/cart";

            } catch (e) {

                console.error(e);

                alert("Something went wrong while adding the bundle.");

                cartBtn.disabled = false;

                cartBtn.innerHTML = "Add Bundle To Cart";

            }

        });

    }

    // Initial Load

    updateUI();

});